<template>
  <div class="award-detail-container">
    <div class="award-wrapper">
      <img :src="awardLog.award_type != 5 ? awardLog.award_cover : awardLog.qrcode.product.cover ">
      <div class="detail">
        <h1 v-if="awardLog.award_type == 5">{{ awardLog.qrcode.product.short_name }} {{awardLog.award_name}}</h1>
        <h1 v-else>{{awardLog.award_name}}</h1>
        <div class="status">状态：<span :style="{color: statusColorDict[awardLog.status]}">{{ statusDict[awardLog.status] }}</span></div>
        <div class="line">
          <span>￥{{awardLog.award_price}}</span>
          <span v-if="awardLog.award_type !== 6">{{createdTime}}</span>
        </div>
        <div class="line" v-if="awardLog.award_type == 6">有效期:{{ awardLog.valid_start_time }} - {{ awardLog.valid_end_time }}</div>
      </div>

    </div>
    <div v-if="awardLog.status == 0 && (awardLog.award_type == 5 || awardLog.award_type == 6 || awardLog.award_price == 666.00)" class="qrcode-wrapper">
      <img :src="qrcodeUrl" />
      <p>凭此二维码扫码核销</p>
      <p>{{awardLog.award_intro}}</p>
    </div>
    <template v-if="awardOrder">
      <div class="express">
        <p>订单状态</p>
        <div class="right">
          <span v-if="awardOrder.status === 0">待发货</span>
          <span v-else-if="awardOrder.status === 1">已发货</span>
          <span v-else-if="awardOrder.status === 2">已完成</span>
        </div>
      </div>
      <div v-if="awardOrder.status>0" class="express">
        <p>物流信息</p>
        <div class="right">
          <span>{{awardOrder.express | expressFilter}}</span>
          <span>{{awardOrder.express_serial}}</span>
        </div>
      </div>
      <div class="bottom-wrapper" v-if="awardOrder.status === 1">
        <div class="botton" @click="confirmOrder">确认收货</div>
      </div>
    </template>

    <div class="bottom-wrapper" v-if="!awardLog.status">
      <div v-if="awardLog.status == 0 && (awardLog.award_type == 5 || awardLog.award_type == 6 || awardLog.award_price == 666.00)" class="botton">前往门店兑换奖品</div>
      <div v-else class="botton" @click="toReceive">领取奖品</div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import qs from 'qs'
import { mapGetters } from 'vuex'
import { Toast } from 'vant'
import { Dialog } from 'vant'

Vue.use(Dialog)
Vue.use(Toast)

export default {
  name: 'AwardDetail',
  data() {
    return {
      awardLog: {},
      awardOrder: null,
      logId: this.$route.query.logId,
      isReceive: true,
      canRequest: true,
      createdTime: '',
      qrcodeUrl: '',
      statusDict: ['未核销', '已核销', '已过期'],
      statusColorDict: ['#b8e986', '#ff6d63', '#747474']
    }
  },
  created() {
    this.getAwardLog()
  },
  filters: {
    expressFilter(express) {
      const expressMap = {
        1: '顺丰快递',
        2: '申通快递',
        3: '中通快递',
        4: '韵达快递',
        5: '天天快递',
        6: '圆通快递'
      }
      return expressMap[express]
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    /**
     * 获取中奖订单详情
     */
    getAwardLog() {
      var that = this
      var url = '/activity/award/log/' + this.logId + '/'
      this.axios.get(url).then(function(res) {
        that.createdTime = res.data.created.split(' ')[0]
        if (!res.code) {
          that.awardLog = res.data
          that.qrcodeUrl = 'https://api.pwmqr.com/qrcode/create/?url=https://guohuaci.qumahudong.com/' + res.data.qrcode.serial
          // 如果中了实物奖，并且已领取，拉取中奖订单信息
          if (res.data.award_type === 0 && res.data.status === 1) {
            that.getAwardOrder()
          }
        }
      })
    },

    /**
     * 获取中奖订单
     */
    getAwardOrder() {
      var that = this
      var url = '/activity/award/order/get?qrcode_id=' + this.awardLog.qrcode.id
      this.axios.get(url).then(function(res) {
        if (!res.code) {
          that.awardOrder = res.data
        }
      })
    },

    /**
     * 领取奖品
     * 若是实物奖品，跳转到领奖页面
     * 若是红包，发送领奖请求
     * 若是虚拟奖品，跳转到奖品链接
     * TODO 增加积分领取方式
     */
    toReceive() {
      // 防止重复点击
      if (!this.canRequest) {
        return
      }
      var that = this
      if (this.awardLog.award_type === 0) {
        // 跳转到领取实物奖品页
        this.$router.push({ path: '/user/award/receive', query: { logId: this.logId }})
      } else if (this.awardLog.award_type === 1) {
        // 领取虚拟奖品
        window.location.href = this.awardLog.award_url
      } else if (this.awardLog.award_type === 2) {
        this.canRequest = false
        // 领取红包
        var params = {
          id: this.awardLog.id
        }
        this.axios.post('/activity/award/receive/', qs.stringify(params)).then(function(res) {
          that.canRequest = true
          if (!res.code) {
            Dialog.alert({
              title: '提示',
              message: '红包已发放，请到微信消息里领取'
            }).then(() => {
              that.$router.push({ path: '/' })
            })
          } else {
            Toast(res.message)
          }
        }).catch(function(error) {
          that.canRequest = true
          console.log(error)
          Toast('领取失败')
        })
      }
    },

    /**
     * 确认收货
     * 已发货的实物订单
     */
    confirmOrder() {
      var that = this
      var params = {
        id: this.awardOrder.id
      }
      var url = '/activity/award/order/confirm/'
      this.axios.post(url, qs.stringify(params)).then(function(res) {
        if (!res.code) {
          that.awardOrder = res.data
          Toast('收货确认成功')
        } else {
          Toast('收货确认失败')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.award-detail-container{
  .award-wrapper{
    display: flex;
    padding: 0 15px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    img{
      width: 90px;
      height: 90px;
    }
    .detail{
      flex: 1;
      line-height: 25px;
      margin-left: 10px;
      .created-time{
        color: #4a4a4a;
        margin-left: 120px;
      }
      h1{
        color: #4a4a4a;
        font-size: 16px;
        font-weight: 400;
        margin: 0;
      }
      p{
        color: #aaaaaa;
        font-size: 12px;
        font-weight: 400;
        max-width: 255px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: wrap;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      span{
        color: #ff6d63;
        font-size: 12px;
        font-weight: 600;
      }
      .line {
        display: flex;
        justify-content: space-between;
      }
    }
  }
  .qrcode-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    margin: 10px auto;
    gap: 10px;
    .title {
      font-size: 16px;
    }
    img {
      width: 220px;
      height: 220px;
    }
    p {
      text-align: center;
      font-size: 14px;
      font-weight: bold;
    }
  }
  .express{
    height: 54px;
    padding: 0 15px;
    margin-top: 5px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    p{
      color: #4a4a4a;
      font-size: 14px;
      font-weight: 400;
    }
    .right{
      span{
        opacity: 0.7;
        color: #4a4a4a;
        font-size: 14px;
        font-weight: 400;
        margin-left: 10px;
      }
      img{
        width: 6px;
        height: 10px;
      }
    }
  }
  .bottom-wrapper{
    width: 100%;
    height: 60px;
    background-color: #ffffff;
    position: fixed;
    bottom: 0;
    .botton{
      width: 350px;
      height: 45px;
      margin: 8px auto;
      bLog-radius: 5px;
      background-color: #5e5ef6;
      color: #ffffff;
      font-size: 16px;
      font-weight: 400;
      line-height: 45px;
      text-align: center;
    }
    .disabled{
      background-color: #848484;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/award/detail.vue